module.exports = __webpack_public_path__ + "img/css.d84f9d47.png";